<template>
	<v-row justify="center">
		<!-- persitent fullscreen en attente de résolution de bug pour le click outside
		https://github.com/vuetifyjs/vuetify/issues/8697
		-->
		<v-dialog :value="estAffiche" persistent fullscreen transition="dialog-bottom-transition">
			<v-card class="overflow-hidden" >
				<v-btn @click="CloseMoreInfo()" fixed fab x-large color="#71BF4B" class="ma-2" style="right:0">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<v-app-bar dark color="primary" shrink-on-scroll prominent
									 :src="cas.Image" scroll-target="#scrolling-techniques"  style="height:250px">
					<template v-slot:img="{ props }">
						<v-img v-bind="props"
									 style="height:250px"></v-img>
					</template>
				</v-app-bar>
				<v-sheet id="scrolling-techniques">
					<v-card-title style="word-break: break-word;line-height:normal">{{cas.Titre}}</v-card-title>
					<v-list three-line subheader>
						<v-row>
							<v-col cols="12" md="12" :lg="getLgColDescription" sm="12" id="colDescription">
								<v-list-item v-show="cas.AvantageEnvironnemental">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(99) }}</v-list-item-title>
										<p class="body-2 dark--text" v-html="cas.AvantageEnvironnemental"></p>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-show="cas.AvantageEconomique">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(100) }}</v-list-item-title>
										<p class="body-2 dark--text" v-html="cas.AvantageEconomique"></p>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-show="cas.DescriptionProjet">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(98) }}</v-list-item-title>
										<p class="body-2 dark--text" v-html="cas.DescriptionProjet"></p>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-show="cas.MarcheApplication">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(89) }}</v-list-item-title>
										<p class="body-2 dark--text">{{ cas.MarcheApplication }}</p>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-show="cas.SiteWebVendeur">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(106) }}</v-list-item-title>
										<p><a class="body-2 dark--text" :href="cas.SiteWebVendeur" target="_blank">{{ cas.SiteWebVendeur }}</a></p>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-show="cas.AdresseCasUtilisation">
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ GetTrad(96) }}</v-list-item-title>
										<p class="body-2 dark--text" v-html="cas.AdresseCasUtilisation"></p>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col cols="12" md="12" :lg="getLgColInfo" sm="12" id="colInfo">
								<v-card class="separator" flat tile>
									<v-row no-gutters>
										<v-col cols="12" md="4" lg="12" sm="12">
											<v-list-item class="noPadding">
												<a :href="cas.SiteWebVendeur" target="_blank">
													<v-list-item-avatar class="noPadding" v-show="cas.LogoVendeur" height="100" width="100">
														<v-img :src="cas.LogoVendeur"></v-img>
													</v-list-item-avatar>
												</a>
												<v-list-item-content>
													<v-list-item-title class="font-weight-bold">
														{{ GetTrad(94) }}

														<p class="body-2 dark--text" style="white-space: normal !important;">
															<a :href="cas.SiteWebVendeur" target="_blank" style="text-decoration: none;">
																{{cas.EntrepriseDeveloppeuse ? cas.EntrepriseDeveloppeuse : 'N/A'}}
															</a>
															<a :href="cas.SiteWebVendeur2" target="_blank" style="text-decoration: none;">
																<span v-show="cas.EntrepriseDeveloppeuse2 != 'N/A'">, {{cas.EntrepriseDeveloppeuse2}}</span>
															</a>
															<a :href="cas.SiteWebVendeur3" target="_blank" style="text-decoration: none;">
																<span v-show="cas.EntrepriseDeveloppeuse3 != 'N/A'">, {{cas.EntrepriseDeveloppeuse3}}</span>
															</a>
														</p>
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-col>
										<v-col cols="12" md="4" lg="12" sm="12">
											<v-list-item class="separatorTop">
												<a :href="cas.SiteWebUtilisateur" target="_blank">
													<v-list-item-avatar class="noPadding" v-show="cas.LogoUtilisateur" height="100" width="100">
														<v-img :src="cas.LogoUtilisateur"></v-img>
													</v-list-item-avatar>
												</a>
												<v-list-item-content>
													<v-list-item-title class="font-weight-bold">
														{{ GetTrad(95) }}
														<a :href="cas.SiteWebUtilisateur" target="_blank" style="text-decoration: none;white-space: normal !important;">
															<p class="body-2 dark--text">{{cas.EntrepriseUtilisatrice ? cas.EntrepriseUtilisatrice : 'N/A'}}</p>
														</a>
													</v-list-item-title>
												</v-list-item-content>

											</v-list-item>
										</v-col>
										<v-col cols="12" md="4" lg="12" sm="12" v-show="cas.SecteurActivite">
											<v-list-item class="separatorTop">
												<v-list-item-content>
													<v-list-item-title class="font-weight-bold">{{ GetTrad(90) }}</v-list-item-title>
													<p class="body-2 dark--text">
														<div v-for="secteur in cas.SecteurActivite">
															<v-img v-if="secteur.icone" :src="secteur.icone" style="display:inline-block;vertical-align:middle;margin-bottom: 0.20em;margin-right:0.20em" width="24" max-height="30"></v-img>
															{{ secteur.name }}
														</div>
													</p>
												</v-list-item-content>
											</v-list-item>
										</v-col>
									</v-row>

									<v-tooltip bottom v-model="showCopied">
										<template #activator={}>
											<v-btn color="blue-grey"
												class="ma-2 white--text" @click="GetShareLink">
												{{ GetTrad(118) }}
												<v-icon right
																dark>
													mdi-share
												</v-icon>
											</v-btn>
										</template>
										<span>{{ GetTrad(119) }}</span>
									</v-tooltip>

								</v-card>
							</v-col>
						</v-row>
					</v-list>
				</v-sheet>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
	import { mapGetters } from 'vuex'
	export default {
		props: {
			estAffiche: Boolean,
			cas: null,
		},
		data() {
			return {
				lgcolInfo: 2,
				showCopied: false,
			}
		},
		computed: {
			...mapGetters({ GetTrad: 'Traduction/GET_BY_ID' }),
			getLgColInfo() {
				if (this.cas.LogoVendeur || this.cas.LogoUtilisateur) {
					return 3
				} else {
					return 2
				}
			}, getLgColDescription() {
				if (this.cas.LogoVendeur || this.cas.LogoUtilisateur) {
					return 9
				} else {
					return 10
				}
			}
		},

		methods: {
			CloseMoreInfo: function () {
				this.$emit('fermer')
			},
			async GetShareLink() {
				navigator.clipboard.writeText(window.location.href.split('?')[0] + "?casid=" + this.cas.EncryptedId);

				this.showCopied = true;
				setTimeout(() => {
					this.showCopied = false
				}, 1500)

			}
		},
	}
</script>

<style scoped>
	.v-list--three-line .v-list-item .v-list-item__avatar, .noPadding {
		margin-top: 0px !important;
		margin-bottom: 0px !important;
	}

	.separatorTop {
		border-top: 1px solid #e5e5e5
	}

	.v-application a {
		color: black;
	}

	@media only screen and (max-width:1024px) {
		#colInfo {
			order: 1;
		}

		#colDescription {
			order: 2;
		}

		.separatorTop {
			border-top: 0px;
			border-left: 1px solid #e5e5e5;
		}
	}

	@media only screen and (min-width:1050px) {
		#colInfo {
			position: fixed;
			right: 20px;
		}
	}

	@media only screen and (max-width:500px) {
		.separatorTop {
			border-top: 1px solid #e5e5e5;
			border-left: 0px;
		}
	}
</style>